import React from 'react';
import { motion } from 'framer-motion';

const programs = [
  {
    title: "Shred Guide",
    description: "A step-by-step ebook guide to losing fat without extreme dieting.",
    image: "/images/summer-shred.webp",
    link: "https://buy.stripe.com/dRm5kDfRu8dAalj89p6sw04",
    featured: true,
  },
  {
    title: "Coming Soon...",
    description: "Stay tuned for more programs!",
    image: null,
    link: "#",
    featured: false,
  },
  {
    title: "Coming Soon...",
    description: "Stay tuned for more programs!",
    image: null,
    link: "#",
    featured: false,
  },
];

const Programs: React.FC = () => {
  return (
    <section className="relative overflow-hidden pt-24 pb-24">
      {/* Decorative pink wave lines */}
      <svg className="absolute inset-0 w-full h-full pointer-events-none" viewBox="0 0 1440 900" preserveAspectRatio="none">
        <path d="M-50,80 C200,-20 400,180 700,80 S1100,-20 1500,130" fill="none" stroke="#c76aa2" strokeWidth="2.5" opacity="0.18" />
        <path d="M-50,150 C200,50 400,250 700,150 S1100,50 1500,200" fill="none" stroke="#d897be" strokeWidth="2" opacity="0.15" />
        <path d="M-50,300 C150,200 350,400 650,280 S1050,180 1500,350" fill="none" stroke="#c76aa2" strokeWidth="2" opacity="0.14" />
        <path d="M-50,500 C250,400 450,600 750,480 S1150,380 1500,520" fill="none" stroke="#d897be" strokeWidth="2" opacity="0.13" />
        <path d="M-50,700 C300,600 500,800 800,680 S1200,560 1500,720" fill="none" stroke="#e6bcd5" strokeWidth="2.5" opacity="0.16" />
      </svg>

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
          >
            <h2 className="text-4xl md:text-5xl font-bold mb-5 tracking-tight text-dark uppercase" style={{ fontFamily: 'Poppins, sans-serif' }}>
              Programs
            </h2>
            <p className="max-w-2xl mx-auto text-lg italic" style={{ color: '#5E495C', fontFamily: 'Poppins, sans-serif' }}>
              Training programs designed to help you reach your goals.
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          {programs.map((program, index) => {
            const CardWrapper = program.link !== '#' ? 'a' : 'div';
            const wrapperProps = program.link !== '#' ? { href: program.link, target: '_blank', rel: 'noopener noreferrer' } : {};
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.15 }}
              >
                <CardWrapper
                  {...wrapperProps}
                  className={`block rounded-xl text-center transition-all duration-300 group backdrop-blur-sm hover:translate-y-[-4px] w-full overflow-hidden p-8 ${
                    program.link !== '#' ? 'cursor-pointer' : ''
                  } ${
                    program.featured
                      ? 'bg-gradient-to-br from-pink-500/20 to-pink-600/10 border-2 border-pink-400/60 shadow-lg shadow-pink-500/20 scale-105'
                      : 'bg-white/60 border border-pink-500/20 hover:bg-white/80 hover:border-pink-400/40'
                  }`}
                >
                  {program.image ? (
                    <div className="w-full mb-5 overflow-hidden rounded-lg">
                      <img
                        src={program.image}
                        alt={program.title}
                        width={717}
                        height={1000}
                        loading="lazy"
                        decoding="async"
                        className="w-full h-auto object-cover group-hover:scale-105 transition-transform duration-300"
                      />
                    </div>
                  ) : (
                    <div className={`w-14 h-14 rounded-full inline-flex items-center justify-center mb-5 group-hover:scale-110 transition-transform duration-300 ${
                      program.featured
                        ? 'bg-pink-500/30 text-pink-300'
                        : 'bg-pink-500/15 text-pink-400'
                    }`}>
                      <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v3.586L7.707 11.293a1 1 0 101.414 1.414l2-2A1 1 0 0011 10V7z" clipRule="evenodd" />
                      </svg>
                    </div>
                  )}
                  <div className="w-full">
                    <h3 className={`font-bold mb-3 uppercase whitespace-nowrap text-center ${
                      program.featured ? 'text-2xl text-pink-600' : 'text-xl text-dark'
                    }`} style={{ fontFamily: 'Poppins, sans-serif' }}>
                      {program.title}
                    </h3>
                    <p className="text-sm leading-relaxed mb-5" style={{ color: '#5E495C', fontFamily: 'Poppins, sans-serif' }}>
                      {program.description}
                    </p>
                  </div>
                </CardWrapper>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Programs;
